import React from "react"

const Departures = ({ searchGroup, dataConfig, count, results, searchQuery, setMatches, isZeroState, noResults, trackProductClick }) => {
  if (!results || results.length === 0) return null
  if (results && results.length > 0) {
    const isAllZeroData = results.every((element) => element.isZeroData === true)
    if ((!isZeroState || noResults) && isAllZeroData) return null
  }

  const url = isZeroState || noResults ? `${results[0].url}?sq=${searchQuery}` : `/flyinformation/afgange?q=${searchQuery}*&sq=${searchQuery}`
  let text = isZeroState || noResults ? results[0].name || "" : ""
  const groupName = isZeroState || noResults ? results[0].displayGroupName : ""
  if (dataConfig.texts && dataConfig.texts.arrivals && text === "") {
    text = dataConfig.texts.departures.searchResultText || ""
    text = text.replace("{{count}}", count)
    text = text.replace("{{searchQuery}}", searchQuery)
  }
  const highlight = setMatches(text, searchQuery)
  return (
    <React.Fragment>
      <li className="general-search-panel__item">
        <a href={url} onClick={trackProductClick}>
          <span className="icon icon--large">
            <svg className="svg-icon svg-icon--planelanding-new">
              <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-planetakeoff">
                <svg id="svg-planetakeoff" viewBox="0 0 36 36" width="100%" height="100%">
                  <path
                    d="M3.158 17.284c-.008-.04-.008-.073-.009-.112 0-.033.002-.062.005-.095l.014-.043a.398.398 0 0 1 .08-.096l.146-.073.998-.182a.614.614 0 0 1 .154-.014 1.683 1.683 0 0 1 .431.057 1.6 1.6 0 0 1 .25.099c.052.027.096.05.15.08l.205.117 1.768 1.297.104.058.112.086.175.057.154.05.047.002c.046-.005.083-.012.13-.019l6.64-1.172c.017-.002.03-.006.047-.011.014-.003.024-.005.032-.013a.45.45 0 0 0 .055-.027c.025-.018.047-.033.069-.053a.358.358 0 0 0 .066-.063c.019-.014.028-.03.04-.047.016-.017.025-.035.037-.054a.649.649 0 0 0 .027-.07.548.548 0 0 0 .025-.086.461.461 0 0 0 .004-.073c0-.023-.005-.045-.008-.068a.257.257 0 0 0-.021-.062c-.006-.016-.014-.028-.019-.042-.01-.015-.014-.03-.026-.046L9.673 7.32a.25.25 0 0 1-.021-.04c-.002-.005-.007-.011-.01-.019l-.012-.047c0-.017-.003-.035-.004-.055l.006-.054.006-.061a.821.821 0 0 1 .023-.075.21.21 0 0 1 .013-.034c.01-.015.02-.023.032-.035.013-.015.029-.026.044-.038.028-.023.056-.042.086-.066h.007l.071-.002 2.325-.475a.703.703 0 0 1 .169-.017 1.327 1.327 0 0 1 .394.067c.044.015.082.03.123.053a2.074 2.074 0 0 1 .277.185l.19.156c.014.015.025.025.037.04l7.408 8.778a.535.535 0 0 0 .07.071c.05.045.1.082.155.124.038.028.071.049.108.074.038.026.07.045.112.069a1.054 1.054 0 0 0 .188.087.48.48 0 0 0 .127.02.533.533 0 0 0 .135-.01l6.266-1.198a6.62 6.62 0 0 1 .565-.08 7.53 7.53 0 0 1 1.526.012 5.414 5.414 0 0 1 .862.16 3.674 3.674 0 0 1 .705.278 1.852 1.852 0 0 1 .578.452c.051.06.087.115.123.185a.6.6 0 0 1 .052.38.897.897 0 0 1-.076.24 1.48 1.48 0 0 1-.124.215c-.051.082-.1.147-.163.222-.076.09-.144.162-.225.245-.094.09-.175.163-.271.245a3.967 3.967 0 0 1-.327.251 4.9 4.9 0 0 1-.359.227 4.426 4.426 0 0 1-.445.228 6.461 6.461 0 0 1-.575.237 6.323 6.323 0 0 1-1.163.322L6.735 22.221c-.053.01-.097.015-.148.019a2.433 2.433 0 0 1-.154.006 1.19 1.19 0 0 1-.21-.017.487.487 0 0 1-.128-.045.118.118 0 0 1-.03-.021l-.124-.1c-.029-.029-.055-.053-.08-.085-.02-.026-.04-.051-.057-.082l-2.603-4.515a.421.421 0 0 1-.043-.097zM21.4 23.305a1.251 1.251 0 1 1 0-2.505c.69 0 1.25.56 1.25 1.253a1.25 1.25 0 0 1-1.25 1.252zm-3.149.4a1.251 1.251 0 1 1 0-2.505c.69 0 1.25.56 1.25 1.253a1.25 1.25 0 0 1-1.25 1.252zM3.656 29.996v-1.973h27.563v1.973H3.656z"
                    fillRule="evenodd"
                  ></path>
                </svg>
              </use>
            </svg>
          </span>
          <span className="text">
            {highlight.parts.map((part, index) => {
              if (part.highlight) {
                return <strong key={index}>{part.text}</strong>
              } else {
                return part.text
              }
            })}
            {groupName ? <em> {groupName}</em> : ""}
          </span>
          <span className="icon">
            <svg className="svg-icon svg-icon--arrowrightangle">
              <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowrightangle">
                <svg id="svg-arrowrightangle" viewBox="0 0 36 36" width="100%" height="100%">
                  <title>_cph-icons1</title>
                  <path className="cls-1" d="M27.17 18L12.48 33l-3.65-3.71L19.89 18l-11-11.26L12.52 3z" id="ICONS"></path>
                </svg>
              </use>
            </svg>
          </span>
        </a>
      </li>
    </React.Fragment>
  )
  //To show one flight - no included in first draft
  // <React.Fragment>
  //       {results.map(result => {
  //         const url = `${config.siteprefix}/flyinformation/afgange?q=${result.Flight}`;
  //         const text = `${result.CarrierName} (${result.Flight})  ${result.DestinationName} (${result.IataDestination})`
  //         const highlight = setMatches(text, searchQuery, 4);

  //         return (
  //           <li className="general-search-panel__item" key={result.id}>
  //             <a href={url} target={"_blank"}>
  //             <span className="icon icon--large">
  // 								<svg className="svg-icon svg-icon--planetakeoff">
  // 									<use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-planetakeoff">
  //                     <svg id="svg-planetakeoff" viewBox="0 0 36 36" width="100%" height="100%">
  //                       <title>_cph-icons1</title>
  //                       <g id="ICONS">
  //                         <path className="cls-1" d="M4.16 19.66l.91-.49.15-.06.22-.05h.88l2.12.7h.65l.12-.06 6-3.21.05-.07v-.08a.19.19 0 0 0 0-.06.6.6 0 0 0 0-.06.59.59 0 0 0 0-.08.5.5 0 0 0 0-.09v-.18L7.24 8.49v-.26-.13l.06-.09h.07L9.4 6.72l.16-.07H10.25l.17.06.23.09 9.97 6.2h.09l.19.07h.6l.13-.05L27.29 10c.18-.1.33-.17.52-.25s.4-.16.62-.24l.44-.13.42-.1.48-.08h1.17a2 2 0 0 1 .37.1 1.86 1.86 0 0 1 .33.16.93.93 0 0 1 .18.14.55.55 0 0 1 .1.14.7.7 0 0 1 .07.21.93.93 0 0 1 0 .26 1.43 1.43 0 0 1-.05.25 2 2 0 0 1-.09.27c0 .11-.09.2-.14.31l-.18.32a4 4 0 0 1-.24.34L31 12a4.54 4.54 0 0 1-.36.36c-.16.15-.3.27-.48.41a6.51 6.51 0 0 1-.56.4 4.84 4.84 0 0 1-.47.27L9.07 23.78l-.14.06-.15.05h-.37l-.15-.06-.1-.06-.08-.06-3.94-3.49-.07-.08A.57.57 0 0 1 4 20v-.25zM4 27.41h28v2H4z">
  //                         </path>
  //                       </g>
  //                     </svg>
  //                    </use>
  // 								</svg>
  // 							</span>
  //             <span className="text">
  //               {highlight.parts.map((part, index) => {
  //                 if(part.highlight) {
  //                   return (
  //                     <strong key={index}>
  //                       {part.text}
  //                     </strong>
  //                   );
  //                 } else {
  //                   return (part.text)
  //                 }

  //               })}
  //               </span>
  //               <span className="icon">
  // 								<svg className="svg-icon svg-icon--arrowrightangle">
  // 									<use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowrightangle">
  //                     <svg id="svg-arrowrightangle" viewBox="0 0 36 36" width="100%" height="100%">
  //                       <title>_cph-icons1</title>
  //                       <path className="cls-1" d="M27.17 18L12.48 33l-3.65-3.71L19.89 18l-11-11.26L12.52 3z" id="ICONS">
  //                       </path>
  //                     </svg>
  //                   </use>
  // 								</svg>
  // 							</span>
  //             </a>
  //           </li>
  //         );
  //       })}
  //     </React.Fragment>
}

export default Departures
